export default __webpack_public_path__ + "static/media/it-34.10fbd345.svg";